import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  
import { statusCheck } from '../public';

export const useReceiptStore = defineStore('receipt', {
  state: () => ({
    results: [],
    filters: {
      date: '',
      amount: '',
      card_last_4_digits: '',
      pick_up: '',
      drop_off: '',
    },
  }),
  actions: {
    async fetchTransactions() {
      const url = `/api/driver/transaction/search`;

      // 建立 FormData 物件
      const formData = new FormData();
      

      const formatDate = (date) => {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      };

      if (this.filters.date) {
        formData.append('date', formatDate(this.filters.date));
      }
      if (this.filters.amount) {
        formData.append('amount', this.filters.amount);
      }
      if (this.filters.card_last_4_digits) {
        formData.append('card_last_4_digits', this.filters.card_last_4_digits);
      }
      if (this.filters.pick_up) {
        formData.append('pick_up', this.filters.pick_up);
      }
      if (this.filters.drop_off) {
        formData.append('drop_off', this.filters.drop_off);
      }

      try {
        const response = await useHttp().post(url, formData);
        
        if (statusCheck(response.data)) {
          this.results = response.data.data;
        } else {
          console.error('Failed to fetch transactions:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
      }
    },
  },
});
